import { store } from '../manager/DataManager';

export const LOW_LIMIT = store.createStore(0);
export const HIGH_LIMIT = store.createStore(350);
export const P1_SPM = store.createStore(0);
export const P2_SPM = store.createStore(0);
